<template>
  <Menu 
    class="ml-2"
    :open="showMenu" 
    @close="showMenu = false"
    placement="bottom"
    >

      <Icon 
        class="cursor-pointer"
        slot="reference"
        @click="handleClick()"
        size="small" 
        :name="Control.breakpoint" />
        
    <ul class="p-0 list-none m-0 text-secondary">
      <MenuItem @click="handleInput('desktop')">
        <Icon class="p-2" size="small" name="desktop" />
      </MenuItem>
      <MenuItem @click="handleInput('tablet')">
        <Icon class="p-2" size="small" name="tablet" />
      </MenuItem>
      <MenuItem @click="handleInput('mobile')">
        <Icon class="p-2" size="small" name="mobile" />
      </MenuItem>
    </ul>
  </Menu>
</template>

<script>

import Icon from '@converdy/atoms/Icon'

export default {
  
  components: { Icon },

  inject: [ 'Control' ],

  data () {
    return {
      showMenu: false,

      icons: {
        mobile: 'mobile',
        tablet: 'tablet',
        desktop: 'desktop'
      }
    }
  },

  methods: {
    handleClick() {
      this.showMenu = ! this.showMenu
    },
    handleInput (value) {
      this.Control.handleBreakpointChange(value)
      this.showMenu = false

    }
  }
}

</script>

<style scoped>

.icon {
  width: 16px;
  height: 16px;
}

</style>
